import { AgEventAPI, InterpolationType } from "@ai360/core";

const getAgEventGeneralGuidsWithSoilZoneSampling = async (
    agEventGeneralGuids: string[],
    userGuid: string
) => {
    const promises = Array.from(new Set<string>(agEventGeneralGuids)).map((agEventGeneralGuid) =>
        AgEventAPI.getAgEvents(userGuid, agEventGeneralGuid)
    );
    const agEvents = await Promise.all(promises);
    const agEventGeneralGuidsWithZoneSampling = agEvents
        .filter((agEvent) => {
            const interpolationTypeId = agEvent.eventAreaList[0].agEventList
                .map((f) => f.agEventModel.interpolationTypeId)
                .filter(Boolean)[0];
            return (
                agEvent.agEventTypeList[0].sampleType === "Soil" &&
                interpolationTypeId &&
                interpolationTypeId === InterpolationType.ZONE_SAMPLING
            );
        })
        .map((agEvent) => agEvent.agEventGeneralGuid);
    return new Set<string>(agEventGeneralGuidsWithZoneSampling);
};

export { getAgEventGeneralGuidsWithSoilZoneSampling };
